import {
    getProviderLoading,
    getProviderReject,
    getProviderRequest,
    getProviderSuccess
} from "../../actions/provider/getAll";

export const getProvider = (formData) => async (dispatch, getState) => {
    dispatch(getProviderLoading());
    try {
        const { data } = await getProviderRequest(formData, getState);
        dispatch(getProviderSuccess(data))
    } catch (error) {
        dispatch(getProviderReject(error))
    }
    return Promise.resolve();
};